import React, { FC } from 'react';
import { TypeAddressRecord } from '@/lib/api/accountManager/types';

export type AddressDisplayProps = {
  address: TypeAddressRecord;
};

const AddressDisplay: FC<AddressDisplayProps> = ({ address }) => {
  const {
    first_name: firstName,
    last_name: lastName,
    company = null,
    line1,
    line2 = null,
    city,
    state,
    zip_code: zipCode,
    country,
  } = address;

  const addressLines = {
    fullName: `${firstName} ${lastName}`,
    company,
    line1,
    line2,
    cityStateZip: `${city}, ${state} ${zipCode}`,
    country,
  } as TypeAddressLines;

  const addressLinesToDisplay = _getDisplayableLines(addressLines);

  const addressHtml = addressLinesToDisplay.map((field) => {
    return <p key={`address-field-${field}`}>{addressLines[field]}</p>;
  });

  return <div>{addressHtml}</div>;
};

type TypeAddressLines = {
  [key: string]: string | null;
};

function _getDisplayableLines(addressLines: TypeAddressLines) {
  return Object.keys(addressLines).filter(
    (field) => addressLines[field] !== null,
  );
}

export default React.memo(AddressDisplay);
